import { render, staticRenderFns } from "./StatsCard2.vue?vue&type=template&id=73c6caae&"
import script from "./StatsCard2.vue?vue&type=script&lang=js&"
export * from "./StatsCard2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports